<template>
  <v-app>
    <v-main style="background-color: #ffffff" class="center">
      <v-img src="@/assets/img/onsa-logo.png"
             @mousemove="logo_img_handler"
             class="mobile-logo mx-auto my-auto" width="300px" height="auto"></v-img>
      <v-container class="login-box mx-auto">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-card color="#f2f2f2" class="rounded-xl text--lighten-4 elevation-0 text-center">
            <v-row>
              <v-col cols="12" class="text-center login-form-title">ورود به پنل کاربری</v-col>
              <v-col cols="12" md="6" lg="6" xl="6" class="mw-300 mx-auto form-box mb-5 text-center">
                <v-card-text >
                  <v-text-field dir="ltr" label="نام کاربری"
                                v-model="username"
                                :rules="[rules.required]"
                                @click="errors=''"
                                class="elevation-0"
                                outlined rounded dense/>
                  <v-text-field
                      v-model="password"
                      dir="ltr"
                      :append-icon="pass_show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="pass_show ? 'text' : 'password'"
                      label="رمز عبور"
                      @click="errors=''"
                      v-on:keyup.enter="submit_auth_data"
                      outlined
                      rounded
                      dense
                      :rules="[rules.required, rules.min]"
                      @click:append="pass_show = !pass_show"
                  ></v-text-field>
                  <ul v-for="e in errors">
                    <li style="color: red">{{e[0]}}</li>
                  </ul>
                <v-btn @click="submit_auth_data" :loading="login_loading" :disabled="!(username && password && password.length >= 8)"
                       block color="success" class="mt-5 submit-btn">
                  ورود
                </v-btn>
                </v-card-text>
              </v-col>
              <v-col cols="6" class="text-left logo-box">
                <v-img src="@/assets/img/onsa-logo.png"
                       @mousemove="logo_img_handler"
                       class="login-logo-img mx-auto" id="login_logo_img" max-width="300" height="auto"></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
    @import '@/assets/css/login.css';
</style>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: 'LoginView',

  data: () => ({
    //
    valid: true,
    pass_show:'',
    username:'',
    password:'',
    errors:{},
    login_loading:false,
    rules: {
      required: value => !!value || 'اجباری',
      min: v => v.length >= 8 || 'حداقل ۸ حرف',
    },
  }),
  created() {
      this.check_have_token();
    },
  methods:{
    check_have_token(){
      if(localStorage.getItem('key')){
        axios.get(`${this.BACKEND_LINK}/api/account/info/`, {
          headers: {'Authorization': `Token ${localStorage.getItem('key')}`}
        }).then((response) => {
          if(response.data.id){
            this.$GLOBAL_DATA.user = response.data;
            localStorage.setItem('user', JSON.stringify(response.data));
            this.$snotify.success(` در حال ورود به عنوان "${response.data["get_full_name"]}"`, 'ورود...');
            setTimeout(()=>{this.check_user_level(response.data);}, 2000)
          }
        }).catch(()=>{
          this.$snotify.error(` لطفا پس از اطمینان از اطلاعات خود مجددا تلاش کنید. `,
              'خطا در صحت سنجی');
        });
      }
    },
    submit_auth_data(){
      if(this.$refs.form.validate()) {
        this.login_loading = true;
        console.log("--------------------------------------")
        console.log(this.BACKEND_LINK)
        axios.post(`${this.BACKEND_LINK}/api/account-auth/login/`,{
          username : this.username,
          password : this.password
        })
            .then((response)=>{
              if(response.data.token){
                localStorage.setItem('key', response.data.token);
                axios.get(`${this.BACKEND_LINK}/api/account/info/`, {
                  headers: {'Authorization': `Token ${localStorage.getItem('key')}`}
                }).then((response) => {
                  this.$GLOBAL_DATA.user = response.data;
                  localStorage.setItem('user', JSON.stringify(response.data));
                  this.$snotify.success(` در حال ورود به عنوان "${response.data["get_full_name"]}"`, 'ورود...');
                  setTimeout(()=>{this.check_user_level(response.data);}, 2000)
                }).catch(()=>{
                  this.$snotify.error(` لطفا پس از اطمینان از اطلاعات خود مجددا تلاش کنید. `,
                      'خطا در صحت سنجی');
                });
              }
            })
            .catch((error)=>{
              if (error.response.data){
                this.errors = error.response.data;
              }
            })
            .finally(()=>{
              this.login_loading = false;
            })
      }

    },
    logo_img_handler(e){
        document.getElementById('login_logo_img').style.transform = `perspective(${e.pageX+20<500?500:e.pageX+20}px) rotateY(${(e.pageX/4)-120}deg)`;
    },
  },
};
</script>
